export default class ResetPasswordViewModel {
    public email: string = '';
}